import { render } from "./SearchPage.vue?vue&type=template&id=4378e222"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
script.render = render

export default script